import { EntityUtils } from '@record-it-npm/synchro-client';
import { UserGroup } from './userGroupTypes';
export class UserGroupUtils {
  public static displayTextGetter = (ug: UserGroup): string => ug.name;
  public static keyGetter = (ug: UserGroup): string => EntityUtils.getTrackingKey(ug);
}